import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APIPhanCong = {
  LIST_PHAN_CONG: `${BASE_API_URL_CAP_DIEN}/phan-cong/list`,
  GET_PHAN_CONG: `${BASE_API_URL_CAP_DIEN}/phan-cong/get`,
  UPDATE_PHAN_CONG: `${BASE_API_URL_CAP_DIEN}/phan-cong/phan-cong`,
  UPDATE_PHAN_CONG_LAI: `${BASE_API_URL_CAP_DIEN}/phan-cong/phan-cong-lai`,
};
